const state = {
  name: ''
}
const getters = {
  getName: state => state.name
}
const mutations = {
  UPDATE_NAME: (state, string) => {
    state.name = string
  }
}
const actions = {
  updateName: (store, name) => {
    store.commit('UPDATE_NAME', name)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
